/**
 * Defines a mapping of custom E-document categories (used for CGE) to their corresponding translation keys.
 */
export const customEDocumentCategoryMap = {
  ADVICE: 'e-documents.category.ADVICE',
  ADVISORY_PROPOSAL: 'e-documents.category.ADVISORY_PROPOSAL',
  BANK_ADVICE: 'e-documents.category.BANK_ADVICE',
  BANK_OTHER: 'e-documents.category.BANK_OTHER',
  BANK_PERFORMANCE: 'e-documents.category.BANK_PERFORMANCE',
  BANK_STATEMENT_OF_ACCOUNT: 'e-documents.category.BANK_STATEMENT_OF_ACCOUNT',
  BANK_TAX: 'e-documents.category.BANK_TAX',
  BANK_TICKET: 'e-documents.category.BANK_TICKET',
  BANK_VALUATION: 'e-documents.category.BANK_VALUATION',
  CLIENT_AML: 'e-documents.category.CLIENT_AML',
  CLIENT_ESG: 'e-documents.category.CLIENT_ESG',
  CLIENT_SUITABILITY: 'e-documents.category.CLIENT_SUITABILITY',
  ENCRYPTED_BANK_ADVICE: 'e-documents.category.ENCRYPTED_BANK_ADVICE',
  ENCRYPTED_BANK_OTHER: 'e-documents.category.ENCRYPTED_BANK_OTHER',
  ENCRYPTED_BANK_PERFORMANCE: 'e-documents.category.ENCRYPTED_BANK_PERFORMANCE',
  ENCRYPTED_BANK_STATEMENT_OF_ACCOUNT: 'e-documents.category.ENCRYPTED_BANK_STATEMENT_OF_ACCOUNT',
  ENCRYPTED_BANK_TAX: 'e-documents.category.ENCRYPTED_BANK_TAX',
  ENCRYPTED_BANK_TICKET: 'e-documents.category.ENCRYPTED_BANK_TICKET',
  ENCRYPTED_BANK_VALUATION: 'e-documents.category.ENCRYPTED_BANK_VALUATION',
  ENCRYPTED_OTHER: 'e-documents.category.ENCRYPTED_OTHER',
  INVOICE: 'e-documents.category.INVOICE',
  MIFID_EXANTE: 'e-documents.category.MIFID_EXANTE',
  MIFID_LOSS_ON_LEVERAGE_POSITION: 'e-documents.category.MIFID_LOSS_ON_LEVERAGE_POSITION',
  MIFID_LOSS_ON_PORTFOLIO: 'e-documents.category.MIFID_LOSS_ON_PORTFOLIO',
  MIFID_SUITABILITY: 'e-documents.category.MIFID_SUITABILITY',
  OTHER: 'e-documents.category.OTHER',
  PERFORMANCE: 'e-documents.category.PERFORMANCE',
  PRE_ADVICE: 'e-documents.category.PRE_ADVICE',
  STATEMENT_OF_ACCOUNT: 'e-documents.category.STATEMENT_OF_ACCOUNT',
  TICKET: 'e-documents.category.TICKET',
  VALUATION: 'e-documents.category.VALUATION',
  VALUATION_EBANKING: 'e-documents.category.VALUATION_EBANKING'
};
